import React from "react";
import ComingSoon from "../../../common/cards/ComingSoon/CommingSoon";
function ViewProfileAbout() {
  return <ComingSoon />;
}

export default ViewProfileAbout;
